import React from "react";
import { MessageCircle, X } from "lucide-react";

const ToggleButton = ({
  isOpen,
  isDark,
  primaryColor,
  onToggle,
  textColor,
}) => {
  return (
    <button
      onClick={onToggle}
      className={`group relative w-16 h-16 rounded-full shadow-2xl transition-all duration-300 flex items-center justify-center text-white overflow-hidden ${
        isOpen ? "rotate-0 scale-100" : "hover:scale-110"
      }`}
      style={{
        background: isOpen
          ? isDark
            ? "#1f2937"
            : "#374151"
          : `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}dd 100%)`,
        boxShadow: isOpen
          ? "0 10px 30px rgba(0,0,0,0.3)"
          : `0 10px 30px ${primaryColor}40`,
        border: "none",
      }}
      aria-label={isOpen ? "Close chat" : "Open chat"}
    >
      <div className="absolute inset-0 rounded-full bg-white/20 scale-0 group-hover:scale-100 transition-transform duration-500"></div>

      <div className="relative z-10 transition-transform duration-300">
        {isOpen ? (
          <X className="w-7 h-7" />
        ) : (
          <>
            <MessageCircle className="w-7 h-7" style={{ color: textColor }} />
            {/* <div className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-[10px] font-bold border-2 border-white animate-pulse">
              1
            </div> */}
          </>
        )}
      </div>
    </button>
  );
};

export default ToggleButton;
